/* eslint-disable import/imports-first */
import React from 'react';
import { BrowserRouter, Switch, Route, Redirect } from 'react-router-dom';

import DashboardLayout from '@layout/Admin';
import Login from '@pages/Login';
import ForgotPassword from '@pages/ForgotPassword';
import TokenPassword from '@pages/TokenPassword';
import ResetPassword from '@pages/ResetPassword';
import ResetPasswordSuccess from '@pages/ResetPasswordSuccess';
import Dashboard from '@pages/Dashboard';
import Internals from '@pages/Users/Internals';
import BulkLoadInternal from '@pages/Users/BulkLoadInternal';
import ImportInternals from '@pages/Users/ImportInternals';
import Admins from '@pages/Users/Admins';
import NewAdmin from '@pages/Users/NewAdmin';
import EditAdmin from '@pages/Users/EditAdmin';
import Sections from '@pages/Sections';
import NewSection from '@pages/Sections/NewSection';
import StepsNewSection from '@pages/Sections/StepsNewSection';
import StepsEditSection from '@pages/Sections/StepsEditSection';
import Documents from '@pages/Documents';
import StepsNewDocument from '@pages/Documents/StepsNewDocument';
import StepsEditDocument from '@pages/Documents/StepsEditDocument';
import ReportDocument from '@pages/Documents/ReportDocument';
import Businness from '@pages/Administrator/Businness'
import NewCompany from '@pages/Administrator/Businness/NewCompany'
import EditCompany from '@pages/Administrator/Businness/EditCompany'
import Countries from '@pages/Administrator/Countries'
import Languages from '@pages/Administrator/Languages'
import DictionaryLanguage from '@pages/Administrator/Languages/Dictionary'
import Profiles from '@pages/Administrator/Profiles'
import NewProfile from '@pages/Administrator/Profiles/NewProfile'
import EditProfile from '@pages/Administrator/Profiles/EditProfile'
import Reports from '@pages/Reports'
import ReportsUSersInternal from '@pages/Reports/UsersInternal'
import ReportsUsersSupplier from '@pages/Reports/UsersSupplier'
import ReportsProcess from '@pages/Reports/Process'
import Emails from '@pages/Emails'
import AddEmail from '@pages/Emails/AddEmail'
import EmailEdit from '@pages/Emails/EditEmail'
import BlacklistDomains from '@pages/Administrator/BlacklistDomains'
import Traslate from '@pages/Settings/Traslate';
import Evaluators from '@pages/Procesos/Evaluators';
import RolesProcess from '@pages/Procesos/Roles';
import DictionaryProcess from '@pages/Procesos/Dictionary';
import TraslateProcess from '@pages/Procesos/DictionaryTraslate';
import AnexosProcess from '@pages/Procesos/Anexos';
import SearchSupplier from '@pages/Users/Supplier';
import SupplierDetail from '@pages/Users/SupplierDetail';
import Bitacora from '@pages/Bitacora';
import TypeUsers from '@pages/Administrator/TypeUsers';
import AllowedSections from '@pages/Administrator/TypeUsers/AllowedSections';
import ValidateTokenContract from '@pages/Procesos/ValidateTokenContract';
import DigitalForm from '@pages/Procesos/DigitalForm';
import DigitalFormEdit from '@pages/Procesos/DigitalForm/DigitalFormEdit';

// UI
import FormLayout from '@components/UI/FormLayout';
import InputDemo from '@components/UI/InputDemo';
import FloatLabelDemo from '@components/UI/FloatLabelDemo';
import InvalidStateDemo from '@components/UI/InvalidStateDemo';
import ButtonDemo from '@components/UI/ButtonDemo';
import TableDemo from '@components/UI/TableDemo';
import ListDemo from '@components/UI/ListDemo';
import TreeDemo from '@components/UI/TreeDemo';
import PanelDemo from '@components/UI/PanelDemo';
import OverlayDemo from '@components/UI/OverlayDemo';
import MenuDemo from '@components/UI/MenuDemo';
import MessagesDemo from '@components/UI/MessagesDemo';
import FileDemo from '@components/UI/FileDemo';
import ChartDemo from '@components/UI/ChartDemo';
import MiscDemo from '@components/UI/MiscDemo';
import DisplayDemo from '@components/UI/DisplayDemo';
import ElevationDemo from '@components/UI/ElevationDemo';
import FlexBoxDemo from '@components/UI/FlexBoxDemo';
import IconsDemo from '@components/UI/IconsDemo';
import GridDemo from '@components/UI/GridDemo';
import SpacingDemo from '@components/UI/SpacingDemo';
import TypographyDemo from '@components/UI/TypographyDemo';
import TextDemo from '@components/UI/TextDemo';
import Crud from '@components/UI/Crud';
import Calendar from '@components/UI/Calendar';
import TimelineDemo from '@components/UI/TimelineDemo';
import EmptyPage from '@components/UI/EmptyPage';
import Documentation from '@components/UI/Documentation';
import LocaleDemo from '@components/UI/LocaleDemo';

// eslint-disable-next-line no-unused-vars
import '../styles/style.scss';
import 'primereact/resources/themes/saga-blue/theme.css';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import 'primeflex/primeflex.css';
import 'prismjs/themes/prism-coy.css';
import '@fullcalendar/core/main.css';
import '@fullcalendar/daygrid/main.css';
import '@fullcalendar/timegrid/main.css';

import PrivateRoute from './privateRouter';

const App = () => (
  <BrowserRouter>
    <Switch>
      <Route exact path="/" component={Login} />
      <Route exact path="/forgot-password" component={ForgotPassword} />
      <Route exact path="/token" component={TokenPassword} />
      <Route exact path="/reset-password" component={ResetPassword} />
      <Route exact path="/reset-password-success" component={ResetPasswordSuccess} />
      <Redirect exact from="/dashboard" to="/sections" />
      <PrivateRoute
        exact
        path="/dashboard"
        component={Dashboard}
        layout={DashboardLayout}
        redi
      />
      <PrivateRoute
        exact
        path="/users/internal"
        component={Internals}
        layout={DashboardLayout}
      />
      <PrivateRoute
        exact
        path="/users/internal/bulk-load"
        component={BulkLoadInternal}
        layout={DashboardLayout}
      />
      <PrivateRoute
        exact
        path="/users/internal/import"
        component={ImportInternals}
        layout={DashboardLayout}
      />
      <PrivateRoute
        exact
        path="/admins"
        component={Admins}
        layout={DashboardLayout}
      />
      <PrivateRoute
        exact
        path="/admin/new"
        component={NewAdmin}
        layout={DashboardLayout}
      />
      <PrivateRoute
        exact
        path="/admin/edit"
        component={EditAdmin}
        layout={DashboardLayout}
      />
      <PrivateRoute
        exact
        path="/sections"
        component={Sections}
        layout={DashboardLayout}
      />
      {/* <PrivateRoute
          exact
          path="/section/new"
          component={NewSection}
          layout={DashboardLayout}
        /> */}
      <PrivateRoute
        exact
        path="/section/new"
        component={StepsNewSection}
        layout={DashboardLayout}
      />
      <PrivateRoute
        exact
        path="/section/edit"
        component={StepsEditSection}
        layout={DashboardLayout}
      />
      <PrivateRoute
        exact
        path="/documents"
        component={Documents}
        layout={DashboardLayout}
      />
      <PrivateRoute
        exact
        path="/document/new"
        component={StepsNewDocument}
        layout={DashboardLayout}
      />
      <PrivateRoute
        exact
        path="/document/edit"
        component={StepsEditDocument}
        layout={DashboardLayout}
      />
      <PrivateRoute
        exact
        path="/document/report"
        component={ReportDocument}
        layout={DashboardLayout}
      />
      <PrivateRoute
        exact
        path="/business"
        component={Businness}
        layout={DashboardLayout}
      />
      <PrivateRoute
        exact
        path="/company/new"
        component={NewCompany}
        layout={DashboardLayout}
      />
      <PrivateRoute
        exact
        path="/company/edit"
        component={EditCompany}
        layout={DashboardLayout}
      />
      <PrivateRoute
        exact
        path="/countries"
        component={Countries}
        layout={DashboardLayout}
      />
      <PrivateRoute
        exact
        path="/languages"
        component={Languages}
        layout={DashboardLayout}
      />
      <PrivateRoute
        exact
        path="/languages/dictionary"
        component={DictionaryLanguage}
        layout={DashboardLayout}
      />
      <PrivateRoute
        exact
        path="/traslate"
        component={Traslate}
        layout={DashboardLayout}
      />
      <PrivateRoute
        exact
        path="/profiles"
        component={Profiles}
        layout={DashboardLayout}
      />
      <PrivateRoute
        exact
        path="/profile/new"
        component={NewProfile}
        layout={DashboardLayout}
      />
      <PrivateRoute
        exact
        path="/profile/edit"
        component={EditProfile}
        layout={DashboardLayout}
      />
      <PrivateRoute
        exact
        path="/reports"
        component={Reports}
        layout={DashboardLayout}
      />
      <PrivateRoute
        exact
        path="/reports/user/internal"
        component={ReportsUSersInternal}
        layout={DashboardLayout}
      />
      <PrivateRoute
        exact
        path="/reports/user/suppliers"
        component={ReportsUsersSupplier}
        layout={DashboardLayout}
      />
      <PrivateRoute
        exact
        path="/reports/process"
        component={ReportsProcess}
        layout={DashboardLayout}
      />
      <PrivateRoute
        exact
        path="/emails"
        component={Emails}
        layout={DashboardLayout}
      />
      <PrivateRoute
        exact
        path="/email/new"
        component={AddEmail}
        layout={DashboardLayout}
      />
      <PrivateRoute
        exact
        path="/email/edit"
        component={EmailEdit}
        layout={DashboardLayout}
      />
      <PrivateRoute
        exact
        path="/blacklist-domains"
        component={BlacklistDomains}
        layout={DashboardLayout}
      />
      <PrivateRoute
        exact
        path="/evaluators"
        component={Evaluators}
        layout={DashboardLayout}
      />
      <PrivateRoute
        exact
        path="/roles"
        component={RolesProcess}
        layout={DashboardLayout}
      />
      <PrivateRoute
        exact
        path="/process-dictionary"
        component={DictionaryProcess}
        layout={DashboardLayout}
      />
      <PrivateRoute
        exact
        path="/process-dictionary/traslate"
        component={TraslateProcess}
        layout={DashboardLayout}
      />
      <PrivateRoute
        exact
        path="/anexos"
        component={AnexosProcess}
        layout={DashboardLayout}
      />
      <PrivateRoute
        exact
        path="/supplier/search"
        component={SearchSupplier}
        layout={DashboardLayout}
      />
      <PrivateRoute
        exact
        path="/supplier/detail"
        component={SupplierDetail}
        layout={DashboardLayout}
      />
      <PrivateRoute
        exact
        path="/bitacora"
        component={Bitacora}
        layout={DashboardLayout}
      />
      <PrivateRoute
        exact
        path="/validate-digital-stamp"
        component={ValidateTokenContract}
        layout={DashboardLayout}
      />
      <PrivateRoute
        exact
        path="/type-users"
        component={TypeUsers}
        layout={DashboardLayout}
      />
      <PrivateRoute
        exact
        path="/type-users/allowed-sections"
        component={AllowedSections}
        layout={DashboardLayout}
      />
      <PrivateRoute
        exact
        path="/digital-form"
        component={DigitalForm}
        layout={DashboardLayout}
      />
      <PrivateRoute
        exact
        path="/digital-form/edit"
        component={DigitalFormEdit}
        layout={DashboardLayout}
      />






      {/* START UI */}
      <PrivateRoute
        exact
        path="/formlayout"
        component={FormLayout}
        layout={DashboardLayout}
      />
      <PrivateRoute
        exact
        path="/input"
        component={InputDemo}
        layout={DashboardLayout}
      />
      <PrivateRoute
        exact
        path="/floatlabel"
        component={FloatLabelDemo}
        layout={DashboardLayout}
      />
      <PrivateRoute
        exact
        path="/invalidstate"
        component={InvalidStateDemo}
        layout={DashboardLayout}
      />
      <PrivateRoute
        exact
        path="/button"
        component={ButtonDemo}
        layout={DashboardLayout}
      />
      <PrivateRoute
        exact
        path="/table"
        component={TableDemo}
        layout={DashboardLayout}
      />
      <PrivateRoute
        exact
        path="/list"
        component={ListDemo}
        layout={DashboardLayout}
      />
      <PrivateRoute
        exact
        path="/tree"
        component={TreeDemo}
        layout={DashboardLayout}
      />
      <PrivateRoute
        exact
        path="/panel"
        component={PanelDemo}
        layout={DashboardLayout}
      />
      <PrivateRoute
        exact
        path="/overlay"
        component={OverlayDemo}
        layout={DashboardLayout}
      />
      <PrivateRoute
        exact
        path="/menu"
        component={MenuDemo}
        layout={DashboardLayout}
      />
      <PrivateRoute
        exact
        path="/messages"
        component={MessagesDemo}
        layout={DashboardLayout}
      />
      <PrivateRoute
        exact
        path="/file"
        component={FileDemo}
        layout={DashboardLayout}
      />
      <PrivateRoute
        exact
        path="/chart"
        component={ChartDemo}
        layout={DashboardLayout}
      />
      <PrivateRoute
        exact
        path="/misc"
        component={MiscDemo}
        layout={DashboardLayout}
      />
      <PrivateRoute
        exact
        path="/display"
        component={DisplayDemo}
        layout={DashboardLayout}
      />
      <PrivateRoute
        exact
        path="/elevation"
        component={ElevationDemo}
        layout={DashboardLayout}
      />
      <PrivateRoute
        exact
        path="/flexbox"
        component={FlexBoxDemo}
        layout={DashboardLayout}
      />
      <PrivateRoute
        exact
        path="/icons"
        component={IconsDemo}
        layout={DashboardLayout}
      />
      <PrivateRoute
        exact
        path="/grid"
        component={GridDemo}
        layout={DashboardLayout}
      />
      <PrivateRoute
        exact
        path="/spacing"
        component={SpacingDemo}
        layout={DashboardLayout}
      />
      <PrivateRoute
        exact
        path="/typography"
        component={TypographyDemo}
        layout={DashboardLayout}
      />
      <PrivateRoute
        exact
        path="/text"
        component={TextDemo}
        layout={DashboardLayout}
      />
      <PrivateRoute
        exact
        path="/locale"
        component={LocaleDemo}
        layout={DashboardLayout}
      />
      <PrivateRoute
        exact
        path="/crud"
        component={Crud}
        layout={DashboardLayout}
      />
      <PrivateRoute
        exact
        path="/calendar"
        component={Calendar}
        layout={DashboardLayout}
      />
      <PrivateRoute
        exact
        path="/timeline"
        component={TimelineDemo}
        layout={DashboardLayout}
      />
      <PrivateRoute
        exact
        path="/empty"
        component={EmptyPage}
        layout={DashboardLayout}
      />
      <PrivateRoute
        exact
        path="/documentation"
        component={Documentation}
        layout={DashboardLayout}
      />
      {/* END UI */}
    </Switch>
  </BrowserRouter>
);

export default App;
